import { Vue, Component, Prop } from 'vue-property-decorator';
import CodeEditor from '@/modules/code/components/code-editor/code-editor.vue';
import CodePreview from '@/modules/code/components/code-preview/code-preview.vue';
import { ChangesObject } from 'components';
import { trimExtraIndentationMultiLineText } from '@/lib/functions/other';
import { empty } from '@/lib/functions/dom-helpers';

@Component({
    components: {
        'code-editor': CodeEditor,
        'code-preview': CodePreview
    },

    mounted() {
        const $slotWrapper: HTMLElement = <HTMLElement>this.$refs.codeWrapper;

        if ($slotWrapper) {
            const $codeWrapper = <HTMLTextAreaElement>$slotWrapper.querySelector(`.${this.$props.wrapperMarkupClass}`);

            this.code = $codeWrapper ? trimExtraIndentationMultiLineText($codeWrapper?.innerHTML?.trim() ?? '') : '';

            empty($codeWrapper);
        }
    }
})
export default class LivePreview extends Vue {
    @Prop({
        default: 'js__code-markup-wrapper'
    })
    wrapperMarkupClass!: string;

    @Prop({
        default: true
    })
    showEditor!: boolean;

    @Prop({
        default: true
    })
    showPreview!: boolean;

    @Prop({
        default() {
            return {};
        }
    })
    codeEditorOptions!: object;

    code: string = '';

    handleCodeChanges({ currentCode }: ChangesObject): void {
        this.code = currentCode;
    }
}
